var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2329 24.0081L17.6564 8.00031C16.912 6.7525 15.0887 6.7525 14.3209 8.00031L4.76867 24.0081C4.00086 25.3037 4.93648 26.9358 6.42428 26.9358H25.5765C27.0887 26.9358 28.0251 25.3046 27.2329 24.0081ZM14.9929 14.1445C14.9929 13.5202 15.4973 12.9924 16.1451 12.9924C16.7695 12.9924 17.2973 13.4967 17.2973 14.1445V18.969C17.2973 19.5934 16.7929 20.1212 16.1451 20.1212C15.5207 20.1212 14.9929 19.6168 14.9929 18.969V14.1445ZM16.1207 23.6958C15.4729 23.6958 14.9685 23.168 14.9685 22.5436C14.9685 21.8958 15.4963 21.3914 16.1207 21.3914C16.7685 21.3914 17.2729 21.9193 17.2729 22.5436C17.2729 23.168 16.7685 23.6958 16.1207 23.6958Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9fc13f9cae2ceda199c5dc24c448c6dc.svg";
export { ForwardRef as ReactComponent };